export default "__VITE_ASSET__DMyoJ1BJ__"